<script>
import { getComponent } from "./ComponentTypes"
import formConfig from "../../config/formConfigWebsite.json"

export default {
  name: "form-config-provider-website",
  functional: true,
  render(createElement) {
    let fieldObjects = formConfig.map(field => {
      let component = getComponent(field.type)
      return { ...field, component }
    })
    return createElement(getComponent("formTemplate"), {
      props: {
        formFields: fieldObjects
      }
    })
  }
}
</script>
